import { BankAccountContainer } from 'features/BankAccount/BankAccountContainer'
import { TBusinessAccountDetails } from 'features/MyCommunity/MyOrganizationCommunity/BankingSetup/types'

export const HospitalDetailsBankAccountsContainer = ({
  businessAccountDetails,
  getBusinessAccountDetails
}: {
  businessAccountDetails: TBusinessAccountDetails
  getBusinessAccountDetails: () => void
}) => {
  return (
    <BankAccountContainer
      businessDetails={businessAccountDetails}
      getBusinessDetails={getBusinessAccountDetails}
    />
  )
}
